/**
 * @GENERATED from Figma node 693:15966
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const MsTeamsBright = function (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) {
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        d="M13.875 10.523c0-.312.253-.565.565-.565h6.996c.311 0 .564.253.564.565v4.123a4.062 4.062 0 1 1-8.125 0z"
      />
      <path
        fill={`url(#${_id2})`}
        d="M7.625 9.474c0-.423.343-.766.766-.766h8.468c.423 0 .766.343.766.766v6.11a5 5 0 1 1-10 0z"
      />
      <circle cx={19.083} cy={7.25} r={2.083} fill="#34439E" />
      <circle cx={19.083} cy={7.25} r={2.083} fill={`url(#${_id3})`} />
      <circle cx={13.667} cy={6} r={2.5} fill={`url(#${_id4})`} />
      <path
        fill="#000"
        fillOpacity={0.3}
        d="M6.375 9.958a2.5 2.5 0 0 1 2.5-2.5H12c.64 0 1.042.854 1.484 1.25h.681c.213.368.335.795.335 1.25v6.25a2.5 2.5 0 0 1-2.5 2.5H8.718s-.468-.625-.635-1.041H6.375z"
      />
      <path
        fill={`url(#${_id5})`}
        d="M2 7.667C2 6.747 2.746 6 3.667 6H12c.92 0 1.667.746 1.667 1.667V16c0 .92-.746 1.667-1.667 1.667H3.667C2.747 17.667 2 16.92 2 16z"
      />
      <path
        fill="#fff"
        d="M10.125 8.708h-5v1.147h1.872v5.103h1.256V9.855h1.872z"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={13.875}
          x2={22.099}
          y1={10.419}
          y2={15.793}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#364088" />
          <stop offset={1} stopColor="#6E7EE1" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={7.625}
          x2={17.625}
          y1={13.961}
          y2={13.961}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#515FC4" />
          <stop offset={1} stopColor="#7084EA" />
        </linearGradient>
        <linearGradient
          id={_id3}
          x1={17}
          x2={21.025}
          y1={5.386}
          y2={8.218}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#364088" />
          <stop offset={1} stopColor="#6E7EE1" />
        </linearGradient>
        <linearGradient
          id={_id4}
          x1={11.881}
          x2={15.095}
          y1={4.214}
          y2={7.964}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4858AE" />
          <stop offset={1} stopColor="#4E60CE" />
        </linearGradient>
        <linearGradient
          id={_id5}
          x1={2}
          x2={13.667}
          y1={11.833}
          y2={11.833}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2A3887" />
          <stop offset={1} stopColor="#4C56B9" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(MsTeamsBright);
export { ForwardRef as MsTeamsBright };
